import {
  Box,
  Button,
  Grid,
  Link,
  SpaceBetween,
  FormField,
  Input,
  StatusIndicator,
  Checkbox,
  Form,
  Popover,
  Autosuggest,
} from "@cloudscape-design/components";
import { useEffect, useState } from "react";
import { GlobalContext, ContentContext } from "../../../context";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { withAuthenticator, Authenticator } from '@aws-amplify/ui-react';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { navigateFn } from "../../../routingHelper";
import useAxios, {
  configure,
  loadCache,
  serializeCache,
  makeUseAxios,
} from 'axios-hooks'
import { leagueId } from '../../../leagueId';
import { RotatingLines, ThreeDots, BallTriangle } from  'react-loader-spinner'
import * as awsui from "@cloudscape-design/design-tokens";
import usePlacesService from "react-google-autocomplete/lib/usePlacesAutocompleteService";
import DatePicker from '../../../components/date-picker/DatePicker';

const apiKey = "2ff73ab3016540b097d3c5cfed50f001f3fb1ce8cf144cc7a9282ee530bb5f2f";
const baseUrl = "https://dev.formularacinggroup.au/api";
const axiosHeaders = { 
  "api-key": apiKey, 
  "Content-Type": "application/json",
}
const seriesId = ""


// function getSeriesData(pathname: string){
//   let seriesData = {
//     name: "",
//     ref: "",
//   }

//   switch (pathname) {
//     case "/f3a-series": {
//       seriesData.name = "F3A"
//       seriesData.ref = "f3a"
//       break;
//     }
//     case "/f4a-series": {
//       seriesData.name = "F4A"
//       seriesData.ref = "f4a"
//       break;
//     }
//     case "/ffa-series": {
//       seriesData.name = "Formula Ford"
//       seriesData.ref = "ffa"
//       break;
//     }
//     case "/s5000-series": {
//       seriesData.name = "S5000"
//       seriesData.ref = "s5000"
//       break;
//     }
//     case "/apjc-series": {
//       seriesData.name = "Asia Pacific Junior Esports"
//       seriesData.ref = "apjc"
//       break;
//     }
//     case "/tri-series": {
//       seriesData.name = "Tri Nations Esports Cup"
//       seriesData.ref = "tri"
//       break;
//     }
//   }

//   return seriesData;
// }


export default function Register() {
  const navigate = navigateFn({
    navigate: useNavigate(),
    location: useLocation(),
  })
  // const navigate = useNavigate();
  const location = useLocation();
  const { user, signOut } = useAuthenticator((context) => [context.user]);
  const { route } = useAuthenticator(context => [context.route]); 
  const { authStatus } = useAuthenticator(context => [context.authStatus]); 

  const [ username, setUsername ] = useState<string>();
  const [ email, setEmail ] = useState<string>();
  const [ givenName, setGivenName ] = useState<string>();
  const [ familyName, setFamilyName ] = useState<string>();
  const [ name, setName ] = useState<string>();
  const [ profilePicture, setProfilePicture ] = useState<string>();
  const [ groups, setGroups ] = useState<string>();
  const [ dob, setDob ] = useState<string>();
  const [ phone, setPhone ] = useState<string>();
  const [ address, setAddress ] = useState<string>();
  const [ maLicenseId, setMaLicenseId ] = useState<number>();
  const [ irUserId, setIrUserId ] = useState<string>();
  const [ irUserName, setIrUserName ] = useState<string>();
  const [ discordId, setDiscordId ] = useState<string>();
  const [ carNum, setCarNum ] = useState<string>();
  const [ secondaryCarNum, setSecondaryCarNum ] = useState<string>();
  const [ tertiaryCarNum, setTertiaryCarNum ] = useState<string>();
  const [ driverBio, setDriverBio ] = useState<string>();
  const [ agreeToSeriesRules, setAgreeToSeriesRules] = useState(false);
  const [ agreeToFrgRules, setAgreeToFrgRules] = useState(false);
  const [placeDetails, setPlaceDetails] = useState<any>();
  const {
    placesService,
    placePredictions,
    getPlacePredictions,
    isPlacePredictionsLoading,
  } = usePlacesService({
    apiKey: "AIzaSyAyAAyFRzCh2NkkvNlLEKmdWHZ1lenQ5nk",
  });
  const options = {
    fields: ["formatted_address", "geometry", "name"],
    strictBounds: false,
    types: ["establishment"],
  };
  let addressUrl = '';
  let country = '';
  let state = '';
  let postCode = 0;

  useEffect(() => {
    // fetch place details for the first element in placePredictions array
    if (placePredictions.length)
      placesService?.getDetails(
        {
          placeId: placePredictions[0].place_id,
        },
        (placeDetails: any) => {
          setPlaceDetails(placeDetails)
        }
      );
  }, [placePredictions]);

  // const axiosConfig = (url:string, method:string, params:{}) => {
  //   return {
  //     url: baseUrl + url,
  //     method: method,
  //     headers: axiosHeaders,
  //     params: params
  //   }
  // }

  // const [{ data: irDriverData, loading: irDriverLoading, error: irDriverError}, getIrDriver] = useAxios(axiosConfig(
  //     "/iracing_driver",
  //     "get",
  //     {
  //       irUserName: name
  //     }
  //   ), { 
  //   manual: true,
  // })

  const [{ data: irDriverData, loading: irDriverLoading, error: irDriverError}, getIrDriver] = useAxios({
    url: baseUrl + "/iracing_driver",
    method: "get",
    headers: axiosHeaders,
    params: {
      irUserName: name
    }
  }, { 
    manual: true,
  })

  const [{ data: leagueDriver, loading: leagueDriverLoading, error: leagueDriverError}, getLeagueDriver] = useAxios({
    url: baseUrl + "/league-driver",
    method: "get",
    headers: axiosHeaders,
    params: {
      leagueId: leagueId,
      driverId: user.getSignInUserSession()!.getIdToken().payload["custom:leagueDriverId"],
    },
  });

  const [{ data: seriesDriver, loading: seriesDriverLoading, error: seriesDriverError}, getSeriesDriver] = useAxios({
    url: baseUrl + "/series-driver",
    method: "get",
    headers: axiosHeaders,
    params: {
      method: "get",
      leagueId: leagueId,
      seriesId: seriesId,
      driverId: user.getSignInUserSession()!.getIdToken().payload["custom:leagueDriverId"],
    },
  });

  const [{ data: updateLeagueDriver, loading: updateLeagueDriverLoading, error: updateLeagueDriverError}, postLeagueDriver] = useAxios({
    url: baseUrl + "/league-driver",
    method: "post",
    headers: axiosHeaders,
    data: {
      leagueId: leagueId,
      driverId: user.getSignInUserSession()!.getIdToken().payload["custom:leagueDriverId"],
      name: name,
      givenName: givenName,
      familyName: familyName,
      email: email,
      address: address,
      addressUrl: addressUrl,
      country: country,
      state: state,
      postCode: postCode,
      dob: dob,
      irUserId: Number(irUserId),
      irUserName: irUserName,
      carNum: carNum? Number(carNum): undefined,
      secondaryCarNum: secondaryCarNum? Number(secondaryCarNum): undefined,
      tertiaryCarNum: tertiaryCarNum? Number(tertiaryCarNum): undefined,
      agreeToFrgRules: agreeToFrgRules,
    }
  }, {
    manual: true,
  });


  const [{ data: updateSeriesDriver, loading: updateSeriesDriverLoading, error: updateSeriesDriverError}, postSeriesDriver] = useAxios({
    url: baseUrl + "/series-driver",
    method: "post",
    headers: axiosHeaders,
    data: {
      leagueId: leagueId,
      driverId: user.getSignInUserSession()!.getIdToken().payload["custom:leagueDriverId"],
      carNum: Number(carNum) ? Number(carNum): undefined,
      secondaryCarNum: Number(secondaryCarNum) ? Number(secondaryCarNum): undefined,
      tertiaryCarNum: Number(tertiaryCarNum) ? Number(tertiaryCarNum): undefined,
      agreeToFrgRules: agreeToFrgRules,
      agreeToSeriesRules: agreeToSeriesRules,
    }
  }, {
    manual: true,
  });


  useEffect(() => {
    if (leagueDriver !== undefined) {
      const userAttributes = user.getSignInUserSession()!.getIdToken().payload
      const username = userAttributes["cognito:username"]
      const groups = userAttributes["cognito:groups"]
      
      setUsername(username);
      setEmail(userAttributes.email);
      setGivenName(userAttributes.given_name);
      setFamilyName(userAttributes.family_name);
      setName(userAttributes.name);
      setProfilePicture(userAttributes.picture);
      setGroups(groups);
      setDob(leagueDriver.dob);
      setPhone(leagueDriver.phone);
      setAddress(leagueDriver.address);
      setMaLicenseId(leagueDriver.maLicenseId);
      setIrUserId(leagueDriver.irUserId);
      setIrUserName(leagueDriver.irUserName);
      setDiscordId(leagueDriver.discordId);
      setCarNum(leagueDriver.carNum);
      setSecondaryCarNum(leagueDriver.secondaryCarNum);
      setTertiaryCarNum(leagueDriver.tertiaryCarNum);
      setDriverBio(leagueDriver.driverBio);
      setAgreeToSeriesRules(leagueDriver.agreeToSeriesRules);
      setAgreeToFrgRules(leagueDriver.agreeToFrgRules);
    }
  }, [leagueDriver]);

  useEffect(() => {
    if (placeDetails !== undefined) {
      addressUrl = placeDetails.url ? placeDetails.url : "";
      placeDetails.address_components.map( ( item:any ) => {
        if (item.types.includes("country")) country =  item.long_name;
        if (item.types.includes("postal_code")) postCode = Number(item.long_name);
        if (item.types.includes("administrative_area_level_1")) state = item.long_name; 
      })
    }
  }, [placeDetails]);

  if (route !== 'authenticated') {
    navigate('/signin')
  }

  return (
    <>   
      <div style={{width: "100%", paddingTop: "50px", paddingBottom: "50px"}}>
        <div className="body-content">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          > 
            { leagueDriverLoading && seriesDriverLoading ? (
              <div style={{
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
              }}>
                <RotatingLines
                  width="50%"
                  strokeWidth="10px"
                  strokeColor={awsui.colorBackgroundButtonPrimaryActive}
                  ariaLabel="loading-driver-profile"
                  visible={true}
                />
              </div>
            ) : (
              <div style={{
                maxWidth: "800px"
              }}>
                <Form
                  actions={
                    <SpaceBetween direction="horizontal" size="xs" key={"FrgProfileFormButtons"}>
                      <Button 
                        variant="primary"
                        formAction="submit"
                        onClick={ () => {
                          postSeriesDriver()
                        }}
                        loading={updateSeriesDriverLoading}
                      >
                        Update FRG Profile
                      </Button>
                    </SpaceBetween>
                  }
                >
                  <SpaceBetween size="xxl" direction="vertical" key={"SeriesRegistrationForm"}>
                    <div style={{
                      display: "flex",
                      fontSize: "28px",
                      fontWeight: "bold",
                      alignItems: "center",
                      width: "100%",
                    }}>
                      <div style={{
                        width: "100%",
                      }}>
                        FRG Profile
                      </div>
                      <div style={{
                        minWidth: "fit-content"
                      }}>
                        <Button 
                          variant="link"
                          href="/profile"
                          onFollow={(event) => {
                            event.preventDefault();
                            navigate(event.detail.href!)
                          }}
                        >
                          Edit Profile
                        </Button>
                      </div>
                    </div>
                    The following default information from your FRG profile will be submitted for the series registration.
                    Update your FRG profile before submitting  
                    <Grid
                      gridDefinition={[
                        { colspan: { default: 12, xs: 12, } },
                        { colspan: { default: 12, xs: 6, } },
                        { colspan: { default: 12, xs: 6, } },
                        { colspan: { default: 12, xs: 8, } },
                        { colspan: { default: 12, xs: 4, } },
                      ]}
                    >  
                      <FormField label="Email Address" stretch >
                        <Input
                          // onChange={({ detail }) => {setEmail(detail.value)}}
                          value={email ? email : ""}
                          disabled
                        />
                      </FormField>
                      <FormField label="First Name" stretch >
                        <Input
                          onChange={({ detail }) => {setGivenName(detail.value.substring(0, 20))}}
                          value={givenName ? givenName : ""}
                          // disabled
                        />
                      </FormField>
                      <FormField label="Last Name" stretch >
                        <Input
                          onChange={({ detail }) => {setFamilyName(detail.value.substring(0, 20))}}
                          value={familyName ? familyName : ""}
                        />
                      </FormField>
                      <FormField label="Address" stretch >
                        <Autosuggest
                          onSelect={ ( { detail } ) => {
                            setAddress(detail.selectedOption?.description!)
                            getPlacePredictions({ input: detail.selectedOption?.description })
                          }}
                          onChange={ ( event ) => {
                            setAddress(event.detail.value.substring(0, 50));
                            getPlacePredictions({ input: event.detail.value });
                          }}
                          disableBrowserAutocorrect
                          placeholder="Enter Address"
                          value={address ? address : ""}
                          options={placePredictions.map((item) => (item))}
                          ariaLabel="Auto select address"
                          loadingText="Loading"
                          statusType={isPlacePredictionsLoading ? "loading" : "finished"}
                          enteredTextLabel={()=>{return ""}}
                        />
                      </FormField>
                      <FormField 
                        label="Date of Birth"
                        stretch
                      >
                        <DatePicker id="date-picker"
                          name='Date of birth'
                          onChange={ ( event ) => {
                            console.log(new Date(event.target.value).toLocaleDateString())
                            setDob(new Date(event.target.value).toLocaleDateString())
                          }}
                          placeholder={new Date(dob ? dob : "now").toLocaleDateString()}
                          value={new Date(dob ? dob : "now").toLocaleDateString()}
                        />  
                      </FormField>
                    </Grid>
                    <div style={{
                        borderRadius: "8px",
                        padding: "15px",
                        background: "#c8cef7",
                      }}>
                      <Grid
                        gridDefinition={[
                          { colspan: { default: 12, xs: 4, } },
                          { colspan: { default: 12, xs: 4, } },
                          { colspan: { default: 12, xs: 4, } },
                        ]}
                      >
                        <FormField label="iRacing User ID" stretch >
                          <Input
                            onChange={({ detail }) => {setIrUserId(detail.value)}}
                            value={irUserId ? irUserId : ""}
                            disabled
                          />
                        </FormField>
                        <FormField label="iRacing Driver Name" stretch>
                          <Input
                            onChange={({ detail }) => {setIrUserName(detail.value)}}
                            value={irUserName ? irUserName : ""}
                            disabled
                          />
                        </FormField>
                        <div style={{
                          display: "flex",
                          height: "100%",
                          justifyContent: "center",
                          // paddingTop: "20px",
                        }}>
                          <Button
                            variant="normal"
                          >
                            iRacing Driver Lookup
                          </Button>
                        </div>
                      </Grid>
                    </div>
                  </SpaceBetween>
                </Form>

                <Form
                  actions={
                    <SpaceBetween direction="horizontal" size="xs" key={"SeriesRegistrationFormButtons"}>
                      <Button formAction="none" variant="link">
                        Cancel
                      </Button>
                        { agreeToFrgRules ? (
                        <Popover
                        dismissButton={false}
                        position="top"
                        size="medium"
                        triggerType="custom"
                        content={
                          <StatusIndicator type="success">
                            Registered Successfully
                          </StatusIndicator>
                        }
                      >
                        <Button 
                          variant="primary"
                          formAction="submit"
                          onClick={ () => {
                            postLeagueDriver()
                            // postSeriesDriver()
                            window.location.reload();
                          }}
                        >
                          Register
                        </Button>
                      </Popover>
                      ):(
                        <Popover
                        dismissButton={false}
                        position="top"
                        size="large"
                        triggerType="custom"
                        content={
                          <StatusIndicator type="error">
                            You must agree to the FRG Privacy Policy and Rules!
                          </StatusIndicator>
                        }
                      >
                        <Button variant="primary">
                          Register
                        </Button>
                      </Popover>
                      )}
                    </SpaceBetween>
                  }
                >
                  <SpaceBetween size="xxl" direction="vertical" key={"SeriesRegistrationFormFields"}>
                    <div style={{
                      display: "flex",
                      fontSize: "28px",
                      fontWeight: "bold",
                      alignItems: "center",
                      paddingTop: "40px",
                      width: "100%",
                    }}>
                      Series Registration
                    </div>
                    <Grid
                      gridDefinition={[
                        { colspan: { default: 12, xs: 4, } },
                        { colspan: { default: 12, xs: 4, } },
                        { colspan: { default: 12, xs: 4, } },
                      ]}
                    >
                      <FormField label="Car # First Preference" >
                        <Input
                          onChange={({ detail }) => {setCarNum(detail.value.substring(0, 3))}}
                          type="number"
                          value={carNum ? carNum : ""}
                        />
                      </FormField>
                      <FormField label="Car # Second Preference" stretch >
                        <Input
                          onChange={({ detail }) => {setSecondaryCarNum(detail.value.substring(0, 3))}}
                          type="number"
                          value={secondaryCarNum ? secondaryCarNum : ""}
                        />
                      </FormField>
                      <FormField label="Car # Third Preference" stretch>
                        <Input
                          onChange={({ detail }) => {setTertiaryCarNum(detail.value.substring(0, 3))}}
                          type="number"
                          value={tertiaryCarNum ? tertiaryCarNum : ""}
                        />
                      </FormField>
                    </Grid>
                    <Box>
                    <Checkbox
                        onChange={({ detail }) =>
                          setAgreeToSeriesRules(detail.checked)
                        }
                        checked={agreeToSeriesRules}
                      >
                        You have read and agree to the FRG rules for the series&nbsp;
                        <Link 
                          href="rules"
                          onFollow={ (event) => {
                            event.preventDefault();
                            navigate(event.detail.href!)
                          }}
                        >
                          here
                        </Link>
                      </Checkbox>
                      <Checkbox
                        onChange={({ detail }) =>
                          setAgreeToFrgRules(detail.checked)
                        }
                        checked={agreeToFrgRules}
                      >
                        You have read and agree to the FRG privacy policy and FRG League Rules.
                      </Checkbox>
                    </Box>
                  </SpaceBetween>
                </Form>
              </div>
            )}
          </div>
        </div>
      </div>
    </>    
  );
}
